export const SET_INITIALIZE_APPLICATION = 'SET_INITIALIZE_APPLICATION';
export const SET_INITIALIZE_SUCCESS = 'SET_INITIALIZE_SUCCESS';
export const SET_INITIALIZE_FAILED = 'SET_INITIALIZE_FAILED';

export function setInitializeApplication(payload) {
	return {
		type: SET_INITIALIZE_APPLICATION,
		payload
	};
}

export function setInitializeSuccess(payload) {
	return {
		type: SET_INITIALIZE_SUCCESS,
		payload
	};
}

export function setInitializeFail(payload) {
	return {
		type: SET_INITIALIZE_FAILED,
		payload
	};
}
